/* global G */
import { setKey } from 'lib/util'
import { setData } from 'lib/sequence/model/api/set'
import session from 'app/_shared/session'

/**
 * AdminNotice Action Submit
 *
 * Fills model with notice and user data.
 *
 * Obtains model's area and type values from current action component's configuration.
 *
 * @param {Gaia.AppModule.Spec} module
 * @returns {function(): function(...[*]): Promise<*[]>}
 */
const submit = module => () => async (...args) => {
  const moduleState = module[G.STATE]
  const model = module[G.MODEL]
  const error = model[G.STATE][G.ERROR]

  setKey(error, G.ERROR, moduleState)

  if (!error) {
    const { area, type } = moduleState[G.ACTION][G.COMPONENT][G.PROPS]
    const user = session(module).user.ref()

    setData(model, {
      area,
      type,
      email: user.value.name,
      accountName: user.value.name,
      lang: module[G.ADAPTER][G.SESSION][G.STATE][G.LANGUAGE],
      submitter: [user.key],
    }, { updateCache: true })
  }

  return args
}

export default submit
